module.exports = __webpack_public_path__ + "img/vasile.76492c83.png";